<div class="playlist" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="1 1 250px">
	<div class="thumbnail-item" fxLayoutAlign="start stretch">
		<img src="assets/img/dummyimg1.png" alt="" class="thumbnail">
	</div>

	<div fxLayout="row" fxLayoutAlign="start start">
		<div class="sub-txt-patch">{{ locale.translate('playlist') }}</div>
	</div>

	<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px" class="playlist-body">
		<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">

			<img src="assets/img/dummyimg1.png" alt="" class="user-icon-small">

			<p class="sub-text-1">{{ locale.translate('author_name') }}</p>
		</div>
		<div>
			<p class="">{{ locale.translate('business_course') }}</p>
		</div>
		<div fxLayout="row" class="star-icon">
			<mat-icon>star</mat-icon>
			<mat-icon>star</mat-icon>
			<mat-icon>star_border</mat-icon>
			<mat-icon>star_border</mat-icon>
			<mat-icon>star_border</mat-icon>
		</div>
	</div>
</div>


<div class="playlist-queue secondary-scroll" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px"
	fxFlex.xs="1 1 auto">
	<div class="queue-item" *ngFor="let list of playList;" [ngClass]="{'selected':list.streaming}" fxLayout="row"
		fxLayoutAlign="start center" fxLayoutGap="10px" (click)="selectData(list)">
		<ng-container *ngIf="list.watched">
			<div class="check-box">
				<mat-icon fontSet="material-icons-outlined">check_box</mat-icon>
			</div>
		</ng-container>
		<div class="queue-item-content" fxFlex="1 1 auto" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="20px">
			<div class="thumbnail" fxFlex="0 0 40px" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
				<img [src]="list.thumbnail" alt="">
			</div>
			<div class="queue-item-info" fxFlex="1 1 auto" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
				<p>{{ list.title }}</p>
			</div>
		</div>
	</div>
</div>
